/**
 * Service: permissionsApi
 */
angular.module('acme.common.service.permissionsApi', [
  'acme.common.factory.QueryStringBuilder'
])
.service('PermissionsApiService',  [ '$http', 'QueryStringBuilderFactory', function($http, QueryStringBuilderFactory) {

    return {

      service: '',

      init: function(endpoint) {
        this.service = endpoint + '/rbac/permissions';
        return this;
      },


      list: function(props) {
        var q = '';
        
        if(props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
            optional: ['page', 'pageSize', 'sortField', 'sortDirection']
            }
          });
          q = qs.query;
        }
        return $http({
          method: 'get',
          url: this.service.replace(/v1/, 'v2') + q
        });
      },

      detail: function(id) {
        return $http({
          method: 'get',
          url: this.service + '/' + id
        });
      },

      remove: function(id) {
        return $http({
          method: 'delete',
          url: this.service + '/' + id
        });
      },

      create: function(props) {
        return $http({
          method: 'post',
          url: this.service,
          data: {
            name: props.name,
            displayName: props.displayName
          }
        });
      },

      batchCreate: function(props) {
        return $http({
          method: 'post',
          url: this.service,
          data: props.mappings
        });
      },

      update: function(props) {
        return $http({
          method: 'put',
          url: this.service,
          data: {
            id: props.id,
            name: props.name,
            displayName: props.displayName
          }
        });
      }


    };

}]);